export default __webpack_public_path__ + "static/media/contributor-new.6944ebb9.svg";